"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import Image from "next/image";
import { motion } from "framer-motion";
import { crmHowItWorks } from "./crm.data";
const ease = [0.17, 0.85, 0.438, 0.99] as const;
export default function CrmHowItWorks() {
  const $ = _c(35);
  const desktopAnimations = useDesktopAnimations();
  let t0;
  if ($[0] !== desktopAnimations) {
    t0 = desktopAnimations ? {
      opacity: 0,
      y: 40
    } : false;
    $[0] = desktopAnimations;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== desktopAnimations) {
    t1 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[2] = desktopAnimations;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== desktopAnimations) {
    t2 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[4] = desktopAnimations;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      duration: 0.6,
      ease
    };
    t4 = {
      once: true
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t0 || $[9] !== t1 || $[10] !== t2) {
    t5 = <motion.h2 initial={t0} whileInView={t1} animate={t2} transition={t3} viewport={t4} className="font-poppins text-[1.9rem] sm:text-[2.25rem] lg:text-[2.5rem] font-bold text-[#141047] mb-5 leading-tight dark:text-white">How Does a Home Service App Work?</motion.h2>;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className="text-gray-500 text-base lg:text-lg mb-8 leading-relaxed max-w-lg mx-auto lg:mx-0 dark:text-gray-300">Our on-demand home service app solutions focus on simplicity and usability. We analyze your business needs to create a seamless experience that attracts and retains customers. The process begins with a service request, which is systematically assigned to a provider and fulfilled at the customer's doorstep. Here's a simple illustration of the workflow.</p>;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== desktopAnimations) {
    t7 = desktopAnimations ? {
      opacity: 0
    } : false;
    $[13] = desktopAnimations;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== desktopAnimations) {
    t8 = desktopAnimations ? {
      opacity: 1
    } : undefined;
    $[15] = desktopAnimations;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== desktopAnimations) {
    t9 = desktopAnimations ? undefined : {
      opacity: 1
    };
    $[17] = desktopAnimations;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      duration: 0.6
    };
    t11 = {
      once: true
    };
    $[19] = t10;
    $[20] = t11;
  } else {
    t10 = $[19];
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t7 || $[22] !== t8 || $[23] !== t9) {
    t12 = <div className="mt-8 flex justify-center lg:justify-start"><motion.img initial={t7} whileInView={t8} animate={t9} transition={t10} viewport={t11} src="/images/crm/how-it-works.png" alt="How Does a Home Service App Work?" className="animate-[float_4s_ease-in-out_infinite] w-full max-w-[480px] object-contain" /></div>;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12 || $[26] !== t5) {
    t13 = <div className="flex flex-col justify-center relative text-center lg:text-left">{t5}{t6}{t12}</div>;
    $[25] = t12;
    $[26] = t5;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== desktopAnimations) {
    t14 = crmHowItWorks.map((item, idx) => <motion.div key={item.title} initial={desktopAnimations ? {
      opacity: 0,
      x: 40
    } : false} whileInView={desktopAnimations ? {
      opacity: 1,
      x: 0
    } : undefined} animate={desktopAnimations ? undefined : {
      opacity: 1,
      x: 0
    }} transition={{
      duration: 0.5,
      delay: idx * 0.1,
      ease
    }} viewport={{
      once: true
    }} className="relative bg-white/70 backdrop-blur-md rounded-2xl p-5 pl-10 flex items-center gap-5 border border-white/50 shadow-[0_8px_30px_rgba(0,0,0,0.04)] hover:shadow-[0_12px_36px_rgba(0,0,0,0.08)] hover:-translate-y-1 transition-all duration-300 ml-4 lg:ml-8 dark:bg-gray-800/80 dark:border-gray-700"><div className="absolute -left-5 top-1/2 -translate-y-1/2 w-10 h-10 bg-white dark:bg-gray-900 rounded-full flex items-center justify-center font-bold text-lg text-[#141047] dark:text-white border border-pink-200 dark:border-gray-700 shadow-sm"><span className="bg-clip-text text-transparent bg-gradient-to-r from-[#ffae86] to-[#ff4f94]">{item.step || idx + 1}</span></div><div className="w-14 h-14 shrink-0 flex items-center justify-center bg-[#f0f8ff] dark:bg-gray-700/80 rounded-lg"><Image src={item.icon} alt={`${item.title} icon`} width={40} height={40} className="w-10 h-10 object-contain" /></div><div><h3 className="font-poppins text-lg font-bold text-[#141047] mb-1 leading-snug dark:text-white">{item.title}</h3><p className="text-gray-500 text-sm leading-relaxed dark:text-gray-300">{item.description}</p></div></motion.div>);
    $[28] = desktopAnimations;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t14) {
    t15 = <div className="flex flex-col gap-6 pl-0 lg:pl-6 pt-4 lg:pt-0">{t14}</div>;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t13 || $[33] !== t15) {
    t16 = <section className="bg-white py-16 md:py-24 px-6 font-sans overflow-hidden dark:bg-gray-950"><div className="max-w-7xl mx-auto"><div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">{t13}{t15}</div></div></section>;
    $[32] = t13;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  return t16;
}